import type { TShowSidebar } from 'contexts/AppContext';

/**
 * CoreUI 5's `visible` of the sidebar for the app's state (CoreUI 3's `show`): 'responsive' shows it from the lg
 * breakpoint on and hides it below, true shows it everywhere, false hides it everywhere.
 */
const sidebarVisible = (showSidebar: TShowSidebar, mobile: boolean): boolean => {
  if (mobile) return showSidebar === true;
  return showSidebar !== false;
};

/**
 * The app's state after CoreUI 5 reports the sidebar's visibility (onVisibleChange). On mobile CoreUI hides an open
 * sidebar itself on a click outside it (the backdrop) or on a link; the state goes back to 'responsive' (hidden
 * there), so the next click on the toggler opens it again. Every other report matches the state already.
 */
export const showSidebarAfterVisibleChange = (
  showSidebar: TShowSidebar,
  visible: boolean,
  mobile: boolean,
): TShowSidebar => {
  if (mobile && !visible && showSidebar === true) return 'responsive';
  return showSidebar;
};

export default sidebarVisible;
